import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';

/**
 * Generated class for the EditindoorprocessesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editindoorprocesses',
  templateUrl: 'editindoorprocesses.html',
})
export class EditindoorprocessesPage {
  cb: any
  id = -1
  name = ''
  DriverUsers = []
  _ud = '0'
  _v = ''
  _mw = '0'
  selectedControllersIds = []
  selectedControllers = '--- ' + this.dic.l["choosecontrollers"] + ' ---';
  idxControllers = ''
  _multipleorders = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController) {
    this.id = this.navParams.get('id')
    this.name = navParams.get('name')
    this.cb = navParams.get('cb')
    this._ud = navParams.get('userid')
    this._v = navParams.get('vehid')
    this._mw = navParams.get('monitoringwith') == undefined ? '0' : navParams.get('monitoringwith')
    this._multipleorders = navParams.get('multipleorders') == '0' ? false : true
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditindoorprocessesPage');
    this.getDriverUsers()
    if (this._v != '') {
      for (var i = 0; i < this._v.split(',').length; i++) {
        this.selectedControllersIds.push(parseInt((this._v.split(','))[i]))
      }
      this.selectedControllers = this.navParams.get('vehicle')
    }
  }

  getDriverUsers() {
    var _that = this
    // this.loadingData = true
    // console.log()
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn._Post('/api/gn/getDriverUsers', _dat, function (_data) {
      _that.DriverUsers = _data
      // console.log(_data  )
    })
  }
  doSave(_id, _name, _op) {
    // console.log(_id, _name, _op)
    var _that = this
    if (this._mw == '0') this._mw = 'beacon'
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      id: this.gn.crypt(_id),
      name: this.gn.crypt(_name),
      userid: this.gn.crypt(this._ud),
      vehid: this.gn.crypt(this.selectedControllersIds),
      monitoringwith: this.gn.crypt(this._mw),
      multipleorders: this._multipleorders == true ? this.gn.crypt('1') : this.gn.crypt('0'),
      op: this.gn.crypt(_op),
      type: this.gn.crypt('Process')
    }
    this.gn._Post('/api/gn/addcolutures', _dat, function (_data) {
      _that.cb()
      _that.navCtrl.pop()
    })
  }

  selectControllers(_ev) {
    var _that = this
    let popover = _that.popoverCtrl.create(PopupPage, {
      type: 'indoor-controllers', selected: '', arrayData: _that.gn.Vehicles, selControllersId: _that.selectedControllersIds, callback: function (_text, _ids) {
        var tmp = []
        _that.selectedControllersIds = []
        for (let ii = 0; ii < _ids.length; ii++) {
          if (_ids[ii].ch) {
            for (var i = 0; i < _that.gn.Vehicles.length; i++) {
              if (_that.gn.Vehicles[i].vehicleid + '' == _ids[ii].id + '') {
                tmp.push(_that.gn.Vehicles[i].registration || ' (' || _that.gn.Vehicles[i].code || ')')
                _that.selectedControllersIds.push(_ids[ii].id)
                _that.idxControllers += ii + ';'
              }
            }

          }
        }
        _that.selectedControllers = tmp.join(', ')
      }
    }, { cssClass: 'popover-content-processes' });
    popover.present({ ev: _ev });
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/indoorprocesses/editindoorprocesses/editindoorprocesses.ts